import { render, staticRenderFns } from "./FilterBox.vue?vue&type=template&id=5357d83f&scoped=true&"
import script from "./FilterBox.vue?vue&type=script&lang=js&"
export * from "./FilterBox.vue?vue&type=script&lang=js&"
import style0 from "./FilterBox.vue?vue&type=style&index=0&id=5357d83f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5357d83f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
